import { PLAYER_CONTEXTS } from "@/constants";

const state = {
  activeSongId: null,
  playerContext: PLAYER_CONTEXTS.playback,
  elapsed: 0,
  duration: 0,
  play: false
};
const mutations = {
  SET_ACTIVE(state, id) {
    state.activeSongId = id;
  },
  SET_CONTEXT(state, playerContext) {
    state.playerContext = playerContext;
  },
  SET_ELAPSED(state, elapsed) {
    state.elapsed = elapsed;
  },
  SET_DURATION(state, duration) {
    state.duration = duration;
  },
  SONG_STATE(state, songState) {
    state.play = songState;
  }
};
const actions = {
  setActiveSongId(context, id) {
    context.commit("SET_ACTIVE", parseInt(id));
  },
  setPlayerContext(context, playerContext) {
    if (Object.values(PLAYER_CONTEXTS).includes(playerContext)) {
      context.commit("SET_CONTEXT", playerContext);
    } else {
      throw new Error("invalid player context");
    }
  },
  setDuration({ commit }, duration) {
    commit("SET_DURATION", duration);
  },
  setElapsed({ commit }, elapsed) {
    commit("SET_ELAPSED", elapsed);
  },
  setPlayState({ commit }, songState) {
    commit("SONG_STATE", songState);
  }
};
const getters = {
  getActiveSongId(state) {
    return state.activeSongId;
  },
  getContext(state) {
    return state.playerContext;
  },
  getCurrentProgress({ elapsed, duration }) {
    return (elapsed / duration) * 100;
  },
  isPlaying(state) {
    if (state.play) {
      return true;
    } else {
      return false;
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
